module.exports = __webpack_public_path__ + "static/img/quiz-correct-s.d821d0d1.svg";